import { render, staticRenderFns } from "./insufficient-amount.vue?vue&type=template&id=a66ee0ea&scoped=true"
import script from "./insufficient-amount.vue?vue&type=script&lang=js"
export * from "./insufficient-amount.vue?vue&type=script&lang=js"
import style0 from "./insufficient-amount.vue?vue&type=style&index=0&id=a66ee0ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66ee0ea",
  null
  
)

export default component.exports